// extracted by mini-css-extract-plugin
module.exports = {"container":"Bill_container__1WjY2","content":"Bill_content__3SPwJ"};